export type ItSpendRow = {
  categoryId?: string;
  min?: number;
  max?: number;
};

export type ItSpendSlice = {
  rows: ItSpendRow[];
};

export const defaultItSpendSlice: ItSpendSlice = {
  rows: [{}],
};
